import { useAuthStore } from "../store/authStore";

export const getGuestUserId = () => {
  const user = useAuthStore.getState().user;
  console.log(user, "userrrr");
  if (!user?.id) {
    return null;
  }

  return user.id;
};
